import SamePage, {ConditionParams} from './_same-page';

interface CoupledParams {
    SubConditions: ConditionParams[],
    Junctor: 'AND' | 'OR',
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(function () {
        /**
         * Client side show condition for SamePageCoupled elements.
         */
        $('.js-same-page-coupled').each(function () {
            const $targetElement = $(this); // Element to be shown or hidden
            const params: CoupledParams = $(this).data('condition-params');

            SamePage.hideTargetElement($targetElement);
            if (isConditionTrue(params)) {
                SamePage.showTargetElement($targetElement);
            }

            // Change target element when source element changes
            for (let key in params.SubConditions) {
                const subCondition = params.SubConditions[key];
                const $sourceElements = SamePage.getInputElementsByItemID(subCondition.ItemID);
                handleChange($sourceElements, $targetElement, params);
            }
        });
    });
}

/**
 * @param $sourceElements
 * @param $targetElement
 * @param params
 *
 * noinspection DuplicatedCode
 */
function handleChange($sourceElements: JQuery, $targetElement: JQuery, params: CoupledParams): void {
    $sourceElements.each(function () {
        const $sourceElement = $(this);
        $sourceElement.on('change', function () {
            if (isConditionTrue(params)) {
                SamePage.showTargetElement($targetElement);
            } else {
                SamePage.hideTargetElement($targetElement);
                SamePage.resetInputField($targetElement); // Delete previously entered data
            }
        });
    });
}

function isConditionTrue(params: CoupledParams): boolean {
    const isJunctorAnd = params.Junctor === 'AND';
    let result = isJunctorAnd; // initial result based on junctor: `true` for AND, `false` for OR
    for (let key in params.SubConditions) {
        const subCondition = params.SubConditions[key];
        const $sourceItems = SamePage.getInputElementsByItemID(subCondition.ItemID);
        let hasElementValue = false; // true if the survey element has been answerd: resp. if at least an element item has a value
        $sourceItems.each(function () {
            if (SamePage.hasValue($(this))) {
                hasElementValue = true;
                const isSubConditionTrue = SamePage.conditionFunction(subCondition, <string>$(this).val());
                if (isJunctorAnd && !isSubConditionTrue) {
                    result = false;
                    return false; // Break the each-loop
                }
                if (!isJunctorAnd && isSubConditionTrue) {
                    result = true;
                    return false; // Break the each-loop
                }
            }
        });
        if (isJunctorAnd && !hasElementValue) {
            return false;
        }
    }
    return result;
}